/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1AccessIdPhotoQueryResponse,
  GetApiV1AccessIdPhotoPathParams,
  GetApiV1AccessIdPhoto401,
  GetApiV1AccessIdPhoto404,
  GetApiV1AccessIdPhoto500,
} from "../../types/personRegisterController/GetApiV1AccessIdPhoto.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1AccessIdPhoto } from "../../clients/personRegisterController/getApiV1AccessIdPhoto.ts";

export const getApiV1AccessIdPhotoQueryKey = (
  id: GetApiV1AccessIdPhotoPathParams["id"],
) => [{ url: "/api/v1/access/:id/photo", params: { id: id } }] as const;

export type GetApiV1AccessIdPhotoQueryKey = ReturnType<
  typeof getApiV1AccessIdPhotoQueryKey
>;

export function getApiV1AccessIdPhotoQueryOptions(
  id: GetApiV1AccessIdPhotoPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1AccessIdPhotoQueryKey(id);
  return queryOptions<
    GetApiV1AccessIdPhotoQueryResponse,
    ResponseErrorConfig<
      | GetApiV1AccessIdPhoto401
      | GetApiV1AccessIdPhoto404
      | GetApiV1AccessIdPhoto500
    >,
    GetApiV1AccessIdPhotoQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1AccessIdPhoto(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a foto de perfil da pessoa.
 * @summary Obter foto de perfil
 * {@link /api/v1/access/:id/photo}
 */
export function useGetApiV1AccessIdPhoto<
  TData = GetApiV1AccessIdPhotoQueryResponse,
  TQueryData = GetApiV1AccessIdPhotoQueryResponse,
  TQueryKey extends QueryKey = GetApiV1AccessIdPhotoQueryKey,
>(
  id: GetApiV1AccessIdPhotoPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1AccessIdPhotoQueryResponse,
        ResponseErrorConfig<
          | GetApiV1AccessIdPhoto401
          | GetApiV1AccessIdPhoto404
          | GetApiV1AccessIdPhoto500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1AccessIdPhotoQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1AccessIdPhotoQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1AccessIdPhoto401
      | GetApiV1AccessIdPhoto404
      | GetApiV1AccessIdPhoto500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
